module.exports = __webpack_public_path__ + "655a347a0c1a88ff1041e32d71ca7763.svg";